import React, { useState, useEffect } from 'react';
import {
  maskPhoneNumber,
  SimpleAlert,
  LoadingGrid,
} from '../../../../_mexablock/helpers';
import { useGetAll } from '../hooks/EstudiantesHook';
import { Filter } from '../_modals/Filter';
import { TableList } from '../../../../_mexablock/helpers/components/TableList';
import { MenuComponent } from '../../../../_mexablock/assets/ts/components';
import { sendPeriodic } from '../../../service/estudiantes/Estudiantes';
import { ConfirmModal } from '../../../../_mexablock/helpers/components/ConfirmationModal';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState<boolean>(true);
  const [initFilterValues, setInitFilterValues] = useState({
    msisdn: '',
    iccid: '',
    nombre: '',
    institution_id: 0,
    education_degree: 0,
  });
  const [visivilityModalConfimation, setVisivilityModalConfimation] =
    useState<boolean>(false);
  const [pendingAction, setPendingAction] = useState<{
    id: number;
    active: boolean;
  } | null>(null);
  const { data, loadingRequest } = useGetAll(initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const columns: any = [
    {
      id: 'fecha_alta',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => row.created_at,
      cell: (row: any) =>
        new Date(row.created_at).toLocaleDateString('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }),
      sortable: true,
    },
    {
      id: 'cliente',
      name: <div className="fw-bolder text-muted me-5">Nombre</div>,
      selector: (row: any) => row.first_name,
      cell: (row: any) =>
        `${row.first_name} ${row.father_last_name} ${row.mother_last_name}`,
      sortable: true,
      width: '200px',
    },
    {
      id: 'email',
      name: <div className="fw-bolder text-muted me-5">Correo</div>,
      selector: (row: any) => row?.email,
      sortable: true,
      width: '230px',
    },
    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row?.iccid,
      sortable: true,
      width: '200px',
    },
    {
      id: 'phone',
      name: <div className="fw-bolder text-muted me-5">Número</div>,
      selector: (row: any) => (row?.phone ? maskPhoneNumber(row.phone) : ''),
      sortable: true,
      width: '130px',
    },
    {
      id: 'educationDegree',
      name: <div className="fw-bolder text-muted me-5">Grado de estudios</div>,
      selector: (row: any) =>
        row.institution?.educationDegree
          ? row.institution.educationDegree.name
          : '',
      sortable: true,
    },
    {
      id: 'institution',
      name: <div className="fw-bolder text-muted me-5">Institución</div>,
      selector: (row: any) => (row.institution ? row.institution.name : ''),
      sortable: true,
      width: '300px',
    },
    {
      id: 'colony',
      name: <div className="fw-bolder text-muted me-5">Colonia</div>,
      selector: (row: any) => (row.colony ? row.colony.name : ''),
      sortable: true,
      width: '200px',
    },
    {
      id: 'periodic_recharge',
      name: <div className="fw-bolder text-muted me-5">Recarga Auto</div>,
      selector: (row: any) => row.periodic_recharge.active,
      cell: (row: any) => (
        <>
          {row.periodic_recharge.active ? (
            <span className="badge badge-light-success">Activo</span>
          ) : (
            <span className="badge badge-light-danger">Inactivo</span>
          )}
        </>
      ),
      sortable: true,
    },
    {
      id: 'acciones',
      name: '',
      cell: (row: any) => dropdownRender(row.periodic_recharge?.active, row.id),
      sortable: false,
    },
  ];

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const dropdownRender = (activo: boolean, id: number) => {
    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <a
            data-kt-menu="true"
            className="btn btn-light btn-active-light-primary btn-sm"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </a>

          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-auto py-4"
            data-kt-menu="true"
          >
            {activo ? (
              <div className="menu-item px-3">
                <a
                  className="menu-link px-3"
                  onClick={() => {
                    setPendingAction({ id, active: false });
                    setVisivilityModalConfimation(true);
                  }}
                >
                  Deshabilitar
                </a>
              </div>
            ) : (
              <div className="menu-item px-3">
                <a
                  className="menu-link px-3"
                  onClick={() => {
                    setPendingAction({ id, active: true });
                    setVisivilityModalConfimation(true);
                  }}
                >
                  Habilitar
                </a>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handlerSendPeriodic = (id: number, active: boolean) => {
    setVisivilityModalConfimation(true);
    sendPeriodic(id, active)
      .then((res) => {
        const {
          data: { message },
        } = res;
        setInitFilterValues({
          msisdn: '',
          iccid: '',
          nombre: '',
          institution_id: 0,
          education_degree: 0,
        });
        SimpleAlert(message, 3000, 'success');
      })
      .catch((err) => {
        let resMessageToast: string = '';
        const {
          data: { message },
        } = err.response;
        resMessageToast = `${message}`;
        SimpleAlert(resMessageToast, 3000, 'error');
      });
  };

  const handleFilter = (values: any) => {
    setInitFilterValues({
      msisdn: values.msisdn,
      iccid: values.iccid,
      nombre: values.nombre,
      institution_id: values.institution_id,
      education_degree: values.education_degree,
    });
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      msisdn: '',
      iccid: '',
      nombre: '',
      institution_id: 0,
      education_degree: 0,
    });
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
              />
              <div className="card-toolbar" title="Nuevo registro"></div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <ConfirmModal
        show={visivilityModalConfimation}
        title=""
        description="¿Deseas guardar y aplicar los cambios realizados?"
        confirmValue={(updateData: boolean) => {
          if (updateData && pendingAction) {
            handlerSendPeriodic(pendingAction.id, pendingAction.active);
          }
          setVisivilityModalConfimation(false);
          setPendingAction(null);
        }}
        onClose={() => {
          setVisivilityModalConfimation(false);
          setPendingAction(null);
        }}
      />
    </>
  );
};

export { View };
